import {Conceptos, tipoDatoConceptoFacturacion} from './../../../../_enums/enum';
import { ConceptoFacturacion } from './../../../../_models/concepto-facturacion';
import { ConceptoFacturacionService } from './../../../../_services/concepto-facturacion.service';
import { PlanCargoConceptoFacturacion } from './../../../../_models/plan-cargo-concepto-facturacion';
import { PlanCargoConceptoFacturacionService } from './../../../../_services/plan-cargo-concepto-facturacion.service';
import { AppSettingService } from './../../../../_services/app-setting.service';
import { ListaService } from './../../../../_services/lista.service';
import { NavService } from './../../../../_services/_nav.service';
import { ListaItem } from './../../../../_models/lista-item';
import { PlanCargo } from './../../../../_models/plan-cargo';
import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import {ConveniosConceptosService} from '../../../../_services/convenios-conceptos.service';
import {ConvenioPlanCargo} from '../../../../_models/convenio-plan-cargo';

@Component({
  selector: 'app-planes-cargos-conceptos',
  templateUrl: './planes-cargos-conceptos.component.html',
  styleUrls: ['./planes-cargos-conceptos.component.css'],
})
export class PlanesCargosConceptosComponent implements OnInit {
  @Input() planCargo: PlanCargo;
  carInformacionInicial = true;
  lisPlanCargoConceptosFacturacion: PlanCargoConceptoFacturacion[] = [];
  planCargoConcepto: PlanCargoConceptoFacturacion = null;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  lisTipoDato: SelectItem[] = [];
  lisIva: SelectItem[] = [];
  lisIvaTodos: ListaItem[] = [];
  lisTipoPago: SelectItem[] = [];
  lisTipoPagoTodos: ListaItem[] = [];
  lisConceptosTodos: ConceptoFacturacion[] = [];
  lisConceptos: SelectItem[] = [];
  lisTipoDatoTodos: ListaItem[] = [];
  lisConvenios: SelectItem[] = [];
  lisConveniosTodos: ConvenioPlanCargo[] = [];
  codTipoDato: string;
  tieneRango = false;
  rangoValido = false;
  ocultarTipoDato = false;
  otrFormaPago: ListaItem;
  conceptos = Conceptos;
  conceptoSeleccionado: ConceptoFacturacion;
  tipoDatoConcepto: ListaItem;
  tipoIva: ListaItem;
  tipoFormaCobro: ListaItem;
  conceptosValoresPreestablecidos: any[];
  habilitarValoresPreestablecidos: boolean = false;

  constructor(
    private planCargoConceptosFacturacionServicio: PlanCargoConceptoFacturacionService,
    private navServicio: NavService,
    private location: Location,
    private lisServicio: ListaService,
    private fb: FormBuilder,
    private conFacturacionServicio: ConceptoFacturacionService,
    private conServicio: ConfirmationService,
    private convenioServicio: ConveniosConceptosService,
    public appSettingService: AppSettingService
  ) {}

  ngOnInit(): void {
    this.guardando = true;
    this.conceptosValoresPreestablecidos = [Conceptos.GARANTIA, Conceptos.RECCRE, Conceptos.SEGDES];
    this.columnas = [
      {
        field: 'nombreConceptoFacturacion',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOCONCEPTO.LBL_CONCEPTOFACTURACION'
        ),
        sort: false,
      },
      {
        field: 'nombreConvenio',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOCONCEPTO.LBL_CONVENIO'
        ),
        sort: false,
      },
      {
        field: 'nombreTipoDatoConcepto',
        header: this.navServicio.buscarMensaje('PRODUCTOCONCEPTO.LBL_TIPODATO'),
        sort: false,
      },
      {
        field: 'valor',
        header: this.navServicio.buscarMensaje('PRODUCTOCONCEPTO.LBL_VALOR'),
        sort: false,
      },
      {
        field: 'desdeHasta',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOCONCEPTO.LBL_DESDEHASTA'
        ),
        sort: false,
      },
      {
        field: 'nombreTipoIva',
        header: this.navServicio.buscarMensaje('PRODUCTOCONCEPTO.LBL_IVA'),
        sort: false,
      },
      {
        field: 'nombreFormaCobroConcepto',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOCONCEPTO.LBL_FORMAPAGO'
        ),
        sort: false,
      },
      {
        field: 'numeroCuotaCobro',
        header: this.navServicio.buscarMensaje(
          'PRODUCTOCONCEPTO.LBL_NUMEROMESCOBRO'
        ),
        sort: false,
      },
      {
        field: 'indicadorHabilitado',
        header: this.navServicio.buscarMensaje('LBL_HABILITADO'),
        sort: false,
      },
      {
        field: 'det',
        header: this.navServicio.buscarMensaje('LBL_ACCIONES'),
        sort: false,
      },
    ];

    forkJoin(
      this.planCargoConceptosFacturacionServicio.listadoPorPlanCargo(
        this.planCargo.idPlanCargo
      ),
      this.lisServicio.getMasterDetails('ListasTiposDatosConceptos'),
      this.lisServicio.getMasterDetails('ListasFormasCobrosConceptos'),
      this.conFacturacionServicio.listadoHabilitados(),
      this.lisServicio.getMasterDetails('ListasTiposIvas'),
      this.convenioServicio.listadoHabilitados(),
    ).subscribe(
      ([
        lisProductosConceptosFacturacion,
        lisTipDato,
        lisTipoPago,
        lisConceptos,
        lisIva,
        lisConvenios
      ]) => {
        this.lisPlanCargoConceptosFacturacion =
          lisProductosConceptosFacturacion;
        this.lisConceptosTodos = lisConceptos;
        this.lisTipoDatoTodos = lisTipDato;
        lisTipDato.map((s: ListaItem) => {
          this.lisTipoDato.push({ label: s.nombre, value: s.idLista });
        });
        this.lisTipoPagoTodos = lisTipoPago;
        lisTipoPago.map((s: ListaItem) => {
          this.lisTipoPago.push({ label: s.nombre, value: s.idLista });
          if (s.codigo === 'OTRFOR') {
            this.otrFormaPago = s;
          }
        });
        this.lisIvaTodos = lisIva;
        lisIva.map((s: ListaItem) => {
          this.lisIva.push({ label: s.nombre, value: s.idLista });
        });
        this.lisTipoDatoTodos = lisTipDato;

        lisConceptos.map((s: ConceptoFacturacion) => {
          if (
            !this.lisPlanCargoConceptosFacturacion.find(
              (x) =>
                x.idConceptoFacturacion === s.idConceptoFacturacion &&
                !s.indicadorRango
            )
          ) {
            this.lisConceptos.push({
              label: s.nombre,
              value: s.idConceptoFacturacion,
            });
          }
        });

        this.lisConvenios = [];
        this.lisConvenios.push({ label: 'Ninguno', value: -1 });

        this.lisConveniosTodos = lisConvenios;
        lisConvenios.map((s: ConvenioPlanCargo ) => {
            this.lisConvenios.push({
              label: `${s.codigo}-${s.nombre}`,
              value: s.idConvenioConcepto,
            });
        });

        this.lisPlanCargoConceptosFacturacion.map(
          (s: PlanCargoConceptoFacturacion) => {
            const rango = this.lisPlanCargoConceptosFacturacion.find(
              (x) =>
                x.idPlanCargoConceptoFacturacion ===
                s.idPlanCargoConceptoFacturacion
            );
            if (rango) {
              s.montoMinimo = rango.montoMinimo;
              s.montoMaximo = rango.montoMaximo;
            } else {
              s.montoMinimo = null;
              s.montoMaximo = null;
            }
            const cobro = this.lisPlanCargoConceptosFacturacion.find(
              (y) =>
                y.indicadorHabilitado &&
                y.idPlanCargoConceptoFacturacion ===
                  s.idPlanCargoConceptoFacturacion
            );
            s.numeroCuotaCobro = cobro ? cobro.numeroCuotaCobro : null;
          }
        );
        this.cargarFormulario();
        this.guardando = false;
        this.carInformacionInicial = false;
      }
    );
  }

  setearValores(setear: boolean = false, info: string) {
    if (setear && info) {
      this.f.idTipoDatoConcepto.setValidators([]);
      this.f.idTipoDatoConcepto.setValue(info);
      this.f.valor.setValidators([]);
      this.f.valor.setValue(0);
    }
  }

  visualizarConcepto(conceptoFacturacion: any[] , visualizar: boolean = false, tipoDato: string) {
    if (visualizar) {
      const codigoConcepto = conceptoFacturacion.find(p => p.codigo === Conceptos.FREELANCE);
      if (this.f.idConceptoFacturacion && codigoConcepto && this.f.idConceptoFacturacion.value === codigoConcepto.idConceptoFacturacion) {
        this.ocultarTipoDato = true;
        this.setearValores(true, tipoDato);
        return;
      }
      this.ocultarTipoDato = false;
    }
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idPlanCargoConceptoFacturacion: [
        this.planCargoConcepto
          ? this.planCargoConcepto.idPlanCargoConceptoFacturacion
          : null,
      ],
      idPlanCargo: [this.planCargo.idPlanCargo, [Validators.required]],
      idConceptoFacturacion: [
        this.planCargoConcepto
          ? this.planCargoConcepto.idConceptoFacturacion
          : null,
        [Validators.required],
      ],
      idTipoDatoConcepto: [
        this.planCargoConcepto
          ? this.planCargoConcepto.idTipoDatoConcepto
          : null,
        [Validators.required],
      ],
      idTipoIva: [
        this.planCargoConcepto ? this.planCargoConcepto.idTipoIva : null,
        [Validators.required],
      ],
      idFormaCobroConcepto: [
        this.planCargoConcepto
          ? this.planCargoConcepto.idFormaCobroConcepto
          : null,
        [Validators.required],
      ],
      valor: [
        this.planCargoConcepto ? this.planCargoConcepto.valor : null,
        [Validators.required, Validators.maxLength(20)],
      ],
      indicadorHabilitado: [
        this.planCargoConcepto
          ? this.planCargoConcepto.indicadorHabilitado
          : true,
      ],
      montoMinimo: [
        this.planCargoConcepto ? this.planCargoConcepto.montoMinimo : null,
      ],
      montoMaximo: [
        this.planCargoConcepto ? this.planCargoConcepto.montoMaximo : null,
      ],
      idConvenioConcepto: [
        this.planCargoConcepto ? this.planCargoConcepto.idConvenioConcepto : null,
      ],
      numeroCuotaCobro: [null],
      auditoriaUsuario: [null],
      auditoriaFecha: [null],
      conceptoFacturacion: [null],
      tipoDatoConcepto: [null],
      tipoIva: [null],
      tipoPago: [null],
    });
  }

  get f() {
    return this.formulario.controls;
  }

  async editar(item: PlanCargoConceptoFacturacion) {
    await this.recargarListas();
    this.planCargoConcepto = item;
    const concepto = this.lisConceptosTodos.find( x => x.idConceptoFacturacion === item.idConceptoFacturacion );
    if (!concepto) {
      this.lisConceptos.push({
        label: item.conceptoFacturacion,
        value: item.idConceptoFacturacion,
      });
    }
    this.f.idPlanCargoConceptoFacturacion.setValue(
      this.planCargoConcepto.idPlanCargoConceptoFacturacion
    );
    this.f.idConvenioConcepto.setValue(
      this.planCargoConcepto.idConvenioConcepto
    );
    this.f.idPlanCargo.setValue(this.planCargoConcepto.idPlanCargo);
    this.f.idConceptoFacturacion.setValue(
      this.planCargoConcepto.idConceptoFacturacion
    );
    this.f.idTipoDatoConcepto.setValue(
      this.planCargoConcepto.idTipoDatoConcepto
    );
    this.f.idTipoIva.setValue(this.planCargoConcepto.idTipoIva);
    this.f.idFormaCobroConcepto.setValue(
      this.planCargoConcepto.idFormaCobroConcepto
    );
    this.f.valor.setValue(this.planCargoConcepto.valor);
    this.f.indicadorHabilitado.setValue(
      this.planCargoConcepto.indicadorHabilitado
    );
    this.codTipoDato = this.buscarTipoDato(item.idTipoDatoConcepto).codigo;
    this.verificarConcepto();
    /*this.proConceptoFacturacionRango = this.lisProConFacRangoTodos.find(
      (x) =>
        x.idProductoConceptoFacturacion ===
        this.productoConcepto.idProductoConceptoFacturacion
    ); */
    this.f.montoMinimo.setValue(
      this.planCargoConcepto ? this.planCargoConcepto.montoMinimo : null
    );
    this.f.montoMaximo.setValue(
      this.planCargoConcepto ? this.planCargoConcepto.montoMaximo : null
    );
    /*this.proConceptoFacturacionCobro = this.lisProductoConceptoCobroTodos.find(
      (y) =>
        y.idProductoConceptoFacturacion ===
        this.productoConcepto.idProductoConceptoFacturacion
    );
    */
    this.cambiarFormaPago(
      this.planCargoConcepto.idFormaCobroConcepto,
      this.planCargoConcepto && this.planCargoConcepto.indicadorHabilitado
        ? this.planCargoConcepto.numeroCuotaCobro
        : null
    );
  }

  cambiarFormaPago(id: string, valor?: number) {
    this.f.numeroCuotaCobro.setValidators(
      this.otrFormaPago && this.otrFormaPago.idLista === id
        ? [Validators.required]
        : []
    );
    this.f.numeroCuotaCobro.setValue(valor);
  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.submitted = true;
    this.conServicio.confirm({
      message: this.navServicio.buscarMensaje(
        'PRODUCTOCONCEPTO.MSG_CONFGUARDADO'
      ),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      key: 'confirmar-guardado',
      accept: () => {
        if (this.formulario.valid) {
          this.guardando = true;
          const planCargoConcepto = this.formulario.value;
          planCargoConcepto.idConvenioConcepto = this.f.idConvenioConcepto.value === -1 ? null : planCargoConcepto.idConvenioConcepto;
          planCargoConcepto.numeroCuotaCobro =  (this.otrFormaPago &&
          this.otrFormaPago.idLista === planCargoConcepto.idFormaCobroConcepto) ? planCargoConcepto.numeroCuotaCobro : null;
          if (this.tieneRango) {
            this.planCargoConceptosFacturacionServicio
              .listadoPorPlanCargoYConcepto(
                this.planCargo.idPlanCargo,
                this.f.idConceptoFacturacion.value
              )
              .subscribe((conceptos) => {
                this.verificarRango(conceptos);
                if (this.rangoValido) {
                  if (planCargoConcepto.idPlanCargoConceptoFacturacion) {
                    /** Actualizar */
                    this.planCargoConceptosFacturacionServicio
                    .actualizar(planCargoConcepto)
                    .subscribe(
                      (concepto) => {
                        this.verificarFinalizar(
                          planCargoConcepto,
                          planCargoConcepto,
                          'ACTUALIZAR',
                          planCargoConcepto.numeroCuotaCobro
                        );
                      },
                      (error) => {
                        this.guardando = false;
                        this.navServicio.setMesage(3);
                      }
                    );
                  } else {
                    /** Crear */
                    this.planCargoConceptosFacturacionServicio
                    .actualizar(planCargoConcepto)
                    .subscribe(
                      (concepto) => {
                        this.verificarFinalizar(
                          planCargoConcepto,
                          planCargoConcepto,
                          'CREAR',
                          planCargoConcepto.numeroCuotaCobro
                        );
                      },
                      (error) => {
                        this.guardando = false;
                        this.navServicio.setMesage(3);
                      }
                    );
                  }
                } else {
                  this.guardando = false;
                  this.submitted = false;
                  this.navServicio.setMesage(0, {
                    severity: 'error',
                    summary: this.navServicio.buscarMensaje('LBL_INFORMACION'),
                    detail: this.navServicio.buscarMensaje(
                      'PRODUCTOCONCEPTO.MSG_ERRORRANGO'
                    ),
                  });
                }
              });
          } else {
            if (planCargoConcepto.idPlanCargoConceptoFacturacion) {
              /** Actualizar */
              this.planCargoConceptosFacturacionServicio
                .actualizar(planCargoConcepto)
                .subscribe(
                  (concepto) => {
                    this.verificarFinalizar(
                      planCargoConcepto,
                      planCargoConcepto,
                      'ACTUALIZAR',
                      planCargoConcepto.numeroCuotaCobro
                    );
                  },
                  (error) => {
                    this.guardando = false;
                    this.navServicio.setMesage(3);
                  }
                );
            } else {
              /** Crear */
              this.planCargoConceptosFacturacionServicio
                .crear(planCargoConcepto)
                .subscribe(
                  (concepto) => {
                    planCargoConcepto.idPlanCargoConceptoFacturacion =
                      concepto.idPlanCargoConceptoFacturacion;
                    this.verificarFinalizar(
                      planCargoConcepto,
                      planCargoConcepto,
                      'CREAR',
                      planCargoConcepto.numeroCuotaCobro
                    );
                  },
                  (error) => {
                    this.navServicio.setMesage(3);
                  }
                );
            }
          }
        }
      },
      reject: () => {
        this.submitted = false;
        this.guardando = false;
      },
    });
  }

  verificarFinalizar(
    planCargoConcepto: PlanCargoConceptoFacturacion,
    rango: any,
    tipo: string,
    numeroCuotaCobro: number
  ) {
    planCargoConcepto.numeroCuotaCobro = numeroCuotaCobro;
    this.subir(planCargoConcepto, tipo);
    if (rango) {
      this.actualizarRangos(
        rango.montoMinimo,
        rango.montoMaximo,
        rango.idPlanCargoConceptoFacturacion
      );
    }
  }

  actualizarRangos(min: any, max: any, id: string) {
    this.lisPlanCargoConceptosFacturacion.map(
      (s: PlanCargoConceptoFacturacion) => {
        if (s.idPlanCargoConceptoFacturacion === id) {
          s.montoMinimo = min;
          s.montoMaximo = max;

          const item = this.lisPlanCargoConceptosFacturacion.find(
            (x) =>
              x.idPlanCargoConceptoFacturacion ===
              s.idPlanCargoConceptoFacturacion
          );
          if (item) {
            item.montoMinimo = min;
            item.montoMaximo = max;
          }
        }
      }
    );
  }

  subir(planCargoConcepto: PlanCargoConceptoFacturacion, tipo: string) {
    switch (tipo) {
      case 'CREAR': {
        const conFacturacion = this.lisConceptos.find(
          (x) => x.value === planCargoConcepto.idConceptoFacturacion
        );
        if (conFacturacion) {
          planCargoConcepto.conceptoFacturacion = conFacturacion.label;
        }

        const tipDato = this.buscarTipoDato(
          planCargoConcepto.idTipoDatoConcepto
        );
        planCargoConcepto.tipoDatoConcepto = tipDato.nombre;
        planCargoConcepto.codigoTipoDatoConcepto = tipDato.codigo;

        const iva = this.lisIva.find(
          (x) => x.value === planCargoConcepto.idTipoIva
        );
        if (iva) {
          planCargoConcepto.tipoIva = iva.label;
        }
        const tipPago = this.lisTipoPago.find(
          (x) => x.value === planCargoConcepto.idFormaCobroConcepto
        );
        if (tipPago) {
          planCargoConcepto.formaCobroConcepto = tipPago.label;
        }
        this.lisPlanCargoConceptosFacturacion = [
          ...this.lisPlanCargoConceptosFacturacion,
          planCargoConcepto,
        ];
        this.formulario.reset();
        this.f.idPlanCargo.setValue(this.planCargo.idPlanCargo);
        this.f.indicadorHabilitado.setValue(true);
        this.recargarListas();
        this.validarConceptoGarantia();
        this.submitted = false;
        this.codTipoDato = null;
        this.guardando = false;
        this.tieneRango = false;
        this.navServicio.setMesage(1);
        break;
      }
      case 'ACTUALIZAR': {
        const conFacturacion = this.lisConceptos.find(
          (x) => x.value === planCargoConcepto.idConceptoFacturacion
        );
        if (conFacturacion) {
          planCargoConcepto.conceptoFacturacion = conFacturacion.label;
        }

        const tipDato = this.buscarTipoDato(
          planCargoConcepto.idTipoDatoConcepto
        );
        planCargoConcepto.tipoDatoConcepto = tipDato.nombre;
        planCargoConcepto.codigoTipoDatoConcepto = tipDato.codigo;

        const iva = this.lisIva.find(
          (x) => x.value === planCargoConcepto.idTipoIva
        );
        if (iva) {
          planCargoConcepto.tipoIva = iva.label;
        }
        const tipPago = this.lisTipoPago.find(
          (x) => x.value === planCargoConcepto.idFormaCobroConcepto
        );
        if (tipPago) {
          planCargoConcepto.formaCobroConcepto = tipPago.label;
        }
        const index = this.lisPlanCargoConceptosFacturacion.findIndex(
          (x) =>
            x.idPlanCargoConceptoFacturacion ===
            planCargoConcepto.idPlanCargoConceptoFacturacion
        );
        this.lisPlanCargoConceptosFacturacion[index] = planCargoConcepto;
        this.planCargoConcepto = null;
        this.formulario.reset();
        this.f.idPlanCargo.setValue(this.planCargo.idPlanCargo);
        this.f.indicadorHabilitado.setValue(true);
        this.recargarListas();
        this.validarConceptoGarantia();
        this.submitted = false;
        this.codTipoDato = null;
        this.guardando = false;
        this.tieneRango = false;
        this.navServicio.setMesage(2);
        break;
      }
      default: {
        break;
      }
    }
  }

  verificarConcepto() {
    this.tieneRango = false;
    const tipoDato = this.lisTipoDatoTodos.find(
      (o) => o.codigo == tipoDatoConceptoFacturacion.PESO
    );
    this.tieneRango = !!this.lisConceptosTodos.find(
      (x) => x.idConceptoFacturacion == this.f.idConceptoFacturacion.value
    ).indicadorRango;
    this.f.montoMinimo.setValidators(
      this.tieneRango ? [Validators.required] : []
    );
    this.f.montoMaximo.setValidators(
      this.tieneRango ? [Validators.required] : []
    );
    this.f.montoMinimo.setValue(null);
    this.f.montoMaximo.setValue(null);
    this.validarConceptoGarantia();
    this.visualizarConcepto(this.lisConceptosTodos, true, tipoDato.idLista );
  }

  validarConceptoGarantia () {
    this.habilitarValoresPreestablecidos = false;
    this.conceptoSeleccionado = this.lisConceptosTodos.find(
      (x) => x.idConceptoFacturacion == this.f.idConceptoFacturacion.value
    );
    if (!this.conceptoSeleccionado) {
      return;
    }

    if (!this.conceptosValoresPreestablecidos.includes(this.conceptoSeleccionado.codigo)) {
      this.f.valor.setValue(this.planCargoConcepto ? this.planCargoConcepto.valor : null);
      this.f.valor.setValidators([Validators.required, Validators.maxLength(20)]);
      this.lisIva = [];
      this.lisTipoDato = [];
      this.lisTipoPago = [];
      this.lisIvaTodos.filter((x) => x.codigo !== this.conceptoSeleccionado.codigo).forEach((iva)=>{
        this.lisIva.push({ label: iva.nombre, value: iva.idLista})
      });
      this.lisTipoDatoTodos.filter((x) => x.codigo !==this.conceptoSeleccionado.codigo).forEach((dato)=>{
        this.lisTipoDato.push({ label: dato.nombre, value: dato.idLista})
      });
      this.lisTipoPagoTodos.filter((x) => x.codigo !== this.conceptoSeleccionado.codigo).forEach((pago)=>{
        this.lisTipoPago.push({ label: pago.nombre, value: pago.idLista})
      });
      return;
    }

    this.lisIva = [];
    this.lisTipoDato = [];
    this.lisTipoPago = [];
    this.lisIvaTodos.forEach((iva)=>{
      this.lisIva.push({ label: iva.nombre, value: iva.idLista})
    });
    this.lisTipoDatoTodos.forEach((dato)=>{
      this.lisTipoDato.push({ label: dato.nombre, value: dato.idLista})
    });
    this.lisTipoPagoTodos.forEach((pago)=>{
      this.lisTipoPago.push({ label: pago.nombre, value: pago.idLista})
    });

    this.tipoDatoConcepto = this.lisTipoDatoTodos.find((x) => x.codigo === this.conceptoSeleccionado.codigo);
    this.tipoIva = this.lisIvaTodos.find((x) => x.codigo === this.conceptoSeleccionado.codigo);
    if (this.conceptoSeleccionado.codigo !== Conceptos.SEGDES) {
      this.tipoFormaCobro = this.lisTipoPagoTodos.find((x) => x.codigo === this.conceptoSeleccionado.codigo);
      this.f.idFormaCobroConcepto.setValue(this.tipoFormaCobro ? this.tipoFormaCobro.idLista : null);
    }
    this.f.idTipoDatoConcepto.setValue(this.tipoDatoConcepto ? this.tipoDatoConcepto.idLista : null);
    this.f.idTipoIva.setValue(this.tipoIva ? this.tipoIva.idLista : null);
    this.habilitarValoresPreestablecidos = true;

    this.f.valor.setValidators([]);
    this.cambioTipoDato(this.f.idTipoDatoConcepto.value);
    this.f.valor.setValue(0);
  }

  async recargarListas() {
    this.lisConceptos = [];
    this.lisPlanCargoConceptosFacturacion = [];
    this.lisPlanCargoConceptosFacturacion = await this.planCargoConceptosFacturacionServicio.listadoPorPlanCargo(
      this.planCargo.idPlanCargo
    ).toPromise();
    this.lisConceptosTodos.map((s: ConceptoFacturacion) => {
      if (
        !this.lisPlanCargoConceptosFacturacion.find(
          (x) =>
            x.idConceptoFacturacion === s.idConceptoFacturacion &&
            !s.indicadorRango
        )
      ) {
        this.lisConceptos.push({
          label: s.nombre,
          value: s.idConceptoFacturacion,
        });
      }
    });
  }

  verificarRango(conceptos: PlanCargoConceptoFacturacion[]) {
    const desde = Number(this.f.montoMinimo.value);
    const hasta = Number(this.f.montoMaximo.value);
    let validoMinMax: boolean;
    let validoRango: boolean;
    validoMinMax =
      desde !== null &&
      hasta !== null &&
      desde !== undefined &&
      hasta !== undefined &&
      Number(desde) < Number(hasta);

    if (conceptos.length === 0 && validoMinMax) {
      this.rangoValido = true;
    } else {
      const esMismoRango = this.planCargoConcepto
        ? !!conceptos.find(
            (y) =>
              y.idPlanCargoConceptoFacturacion ===
                this.planCargoConcepto.idPlanCargoConceptoFacturacion &&
              y.montoMinimo === desde &&
              y.montoMaximo === hasta
          )
        : false;

      if (esMismoRango) {
        validoRango = true;
      } else {
        if (
          this.planCargoConcepto &&
          (this.planCargoConcepto.idPlanCargoConceptoFacturacion !== '' &&
          this.planCargoConcepto.idPlanCargoConceptoFacturacion !== null &&
          this.planCargoConcepto.idPlanCargoConceptoFacturacion !== undefined)
        ) {
          validoRango = !conceptos.find(
            (y) =>
              ((y.montoMinimo <= desde && desde < y.montoMaximo) ||
                (y.montoMinimo < hasta && hasta <= y.montoMaximo)) &&
              this.planCargoConcepto &&
              y.idPlanCargoConceptoFacturacion !==
                this.planCargoConcepto.idPlanCargoConceptoFacturacion
          );
        } else {
          validoRango = !conceptos.find(
            (y) =>
              (y.montoMinimo <= desde && desde < y.montoMaximo) ||
              (y.montoMinimo < hasta && hasta <= y.montoMaximo)
          );
        }
      }

      this.rangoValido = validoMinMax && validoRango;
    }
  }

  cambioTipoDato(tipo: string) {
    this.f.valor.setValue(null);
    this.codTipoDato = this.buscarTipoDato(tipo).codigo;
    this.setearValores(false, tipo);
  }

  buscarTipoDato(tipo: string): ListaItem {
    const a = this.lisTipoDatoTodos.find((x) => x.idLista === tipo);
    if (a) {
      return a;
    } else {
      return new ListaItem();
    }
  }

  regresarFormulario(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'concepto-facturacion',
        accept: () => {
          this.formulario.reset();
          this.planCargoConcepto = null;
          this.f.idPlanCargo.setValue(this.planCargo.idPlanCargo);
          this.f.indicadorHabilitado.setValue(true);
          this.submitted = false;
          this.codTipoDato = null;
        },
        reject: () => {},
      });
    } else {
      this.formulario.reset();
      this.planCargoConcepto = null;
      this.f.idPlanCargo.setValue(this.planCargo.idPlanCargo);
      this.f.indicadorHabilitado.setValue(true);
      this.submitted = false;
      this.codTipoDato = null;
    }
  }
}
